/**
 * Normalize a stored date string to the site's unified yyyy/mm/dd display
 * style. Handles the API's ISO DateField output ("2025-03-23") and the legacy
 * numeric style ("23.03.2025"); anything else (free text, already-formatted
 * ranges) passes through unchanged.
 */
export function formatDisplayDate(value) {
  if (!value) return "";
  const s = String(value).trim();
  const pad = (n) => String(n).padStart(2, "0");
  let m = /^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec(s);
  if (m) return `${m[1]}/${pad(m[2])}/${pad(m[3])}`;
  m = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/.exec(s);
  if (m) return `${m[3]}/${pad(m[2])}/${pad(m[1])}`;
  return s;
}

/**
 * Sort a list block's items by an ISO/display date key. `mode` is the value of
 * the list sorter: "default" keeps the curated portal order (as received),
 * "newest"/"oldest" sort by date with undated items always last.
 */
export function sortByDate(items, mode, key) {
  const list = [...(items || [])];
  if (mode !== "newest" && mode !== "oldest") return list;
  const dir = mode === "newest" ? -1 : 1;
  return list.sort((a, b) => {
    const da = a?.[key] || "";
    const db = b?.[key] || "";
    if (da === db) return 0;
    if (!da) return 1;
    if (!db) return -1;
    return da < db ? -dir : dir;
  });
}
